import ChannelAuthen from '@/api/ChannelAuthen'

// initial state
const state = {

}

// getters
const getters = {

}

// mutations
const mutations = {

}

// actions
const actions = {
  async LoginLine ({ commit }, data) {
    var result = null

    try {
      // clear error
      this.dispatch('Error', null)

      let response = await ChannelAuthen.LoginLine(data)

      result = response.data

      if (result.success) {

      } else {
        // error
        this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
      }
    } catch (e) {
      // error
      this.dispatch('Error', e)
    }

    return result
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/ChannelAuthen.js